import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { TheSidebar, TheFooter, TheHeader } from "../../containers/index";
import { AgGridReact } from "ag-grid-react";
import { AllModules } from "@ag-grid-enterprise/all-modules";
import Select from "react-select";
import {
  getAllMembers,
  getAllServices,
  GetFilterTickets,
  ticketInsert,
} from "../../actions";
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CFormGroup,
  CRow,
  CLabel,
  CTextarea,
} from "@coreui/react";
class ticketsmanage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columnDefs: [
        {
          headerName: "Ticket No",
          field: "ticketno",
        },
        {
          headerName: "Service Name",
          field: "service",
        },
        { headerName: "FullName", field: "fullname" },
        {
          headerName: "Address",
          field: "address",
          filter: "agTextColumnFilter",
        },
        { headerName: "Phone", field: "mobile" },
        { headerName: "Request Mode", field: "requestmode" },
        {
          headerName: "Request Date",
          field: "requestdate",
          filter: "agDateColumnFilter",
        },
        {
          headerName: "Completed",
          field: "requestcompleted",
          filter: "agDateColumnFilter",
        },
      ],
      selServiceValue: [],
      selMemberValue: [],
    };
  }

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  };

  componentDidMount() {
    this.props.getAllServices();
    this.props.getAllMembers();
    this.props.GetFilterTickets(0);
  }

  handleMemberChange = (selectedOption) => {
    this.setState({ selMemberValue: selectedOption });
  };

  handleServiceChange = (selectedOption) => {
    this.setState({ selServiceValue: selectedOption });
  };

  onInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = async () => {
    // alert("Hi")
    let userdetails = [];
    userdetails.push(this.state.selMemberValue);
    // console.log("userdetails", userdetails);
    let objTicket = {
      userdetails: userdetails,
      memberid: this.state.selMemberValue.id,
      serviceid: this.state.selServiceValue.id,
      service : this.state.selServiceValue.label,
      requestmode: "WEB",
      remarks: this.state.remarks,
    };
    await this.props.ticketInsert(objTicket, 0);

    this.handleClear();
  };

  handleClear = async () => { 
    this.setState({
      selServiceValue: '',
      selMemberValue: '',
      remarks: ''
    });
    this.props.GetFilterTickets(0);
  }
  render() {
    if (this.props.auth.redirectToApplication === undefined) {
      return <Redirect to="/login" />;
    }
    return (
      <>
        <div className="c-app c-default-layout">
          <TheSidebar />
          <div className="c-wrapper">
            <TheHeader />
            <div className="c-body">
              <main className="c-main">
                <div className="container-fluid">
                  <div className="fade show">
                    <CRow>
                      <CCol xs="12" sm="4">
                        <CCard>
                          <CCardHeader>Manage Tickets</CCardHeader>
                          <CCardBody>
                            <CRow>
                              <CCol xs="12">
                                <CFormGroup>
                                  <CLabel htmlFor="ccmonth">Members</CLabel>
                                  <Select
                                    value={this.state.selMemberValue}
                                    onChange={this.handleMemberChange}
                                    options={this.props.get_All_Members}
                                  />
                                </CFormGroup>
                              </CCol>
                            </CRow>
                            <CRow>
                              <CCol xs="12">
                                <CFormGroup>
                                  <CLabel htmlFor="ccmonth">Services</CLabel>
                                  <Select
                                    value={this.state.selServiceValue}
                                    onChange={this.handleServiceChange}
                                    options={this.props.get_All_Services}
                                  />
                                </CFormGroup>
                              </CCol>
                            </CRow>
                            <CRow>
                              <CCol xs="12">
                                <CFormGroup>
                                  <CLabel htmlFor="ccmonth">Remarks</CLabel>
                                  <CTextarea
                                    id="remarks"
                                    name="remarks"
                                    value={this.state.remarks}
                                    onChange={this.onInputChange}
                                    rows={5}
                                  ></CTextarea>
                                </CFormGroup>
                              </CCol>
                            </CRow>
                            <CRow>
                              <CCol xs="6">
                                <CFormGroup>
                                  <CButton
                                    block
                                    color="success"
                                    onClick={this.handleSubmit}
                                  >
                                    Submit
                                  </CButton>
                                </CFormGroup>
                              </CCol>
                              <CCol xs="6">
                                <CFormGroup>
                                  <CButton block color="danger"
                                    onClick={this.handleClear}
                                  >
                                    Cancel
                                  </CButton>
                                </CFormGroup>
                              </CCol>
                            </CRow>
                          </CCardBody>
                        </CCard>
                      </CCol>
                      <CCol xs="12" sm="8">
                        <CCard>
                          <CCardHeader>TicketList</CCardHeader>
                          <CCardBody>
                            <CFormGroup>
                              <div
                                className="ag-theme-balham"
                                style={{
                                  height: "500px",
                                  width: "100%",
                                }}
                              >
                                <AgGridReact
                                  columnDefs={this.state.columnDefs}
                                  rowData={this.props.getFilterTickets}
                                  modules={AllModules}
                                  //   onGridReady={this.onGridReady}
                                  defaultColDef={{
                                    filter: true,
                                    floatingFilter: true,
                                    resizable: true,
                                  }}
                                ></AgGridReact>
                              </div>
                            </CFormGroup>
                          </CCardBody>
                        </CCard>
                      </CCol>
                    </CRow>
                  </div>
                </div>
              </main>
            </div>
            <TheFooter />
          </div>
        </div>
      </>
    );
  }
}
const mapStateToProps = ({
  auth,
  get_All_Services,
  get_All_Members,
  getFilterTickets,
}) => {
  return { auth, get_All_Services, get_All_Members, getFilterTickets };
};
export default connect(mapStateToProps, {
  getAllMembers,
  getAllServices,
  GetFilterTickets,
  ticketInsert,
})(ticketsmanage);
